import { Component, Input } from '@angular/core';

import { FieldConfig } from '@vendasta/platform-integrations';

@Component({
  selector: 'platform-integration-works-with',
  imports: [],
  templateUrl: './works-with.component.html',
  styleUrl: './works-with.component.scss',
})
export class WorksWithComponent {
  @Input() worksWithData: FieldConfig[] = [];
}
